import React from 'react';
import { spacer8, Text } from '@spotify-internal/encore-web';

import { DocumentLink } from 'lib/sanity/types';
import { useTranslation } from 'providers/translations/TranslationProvider';
import { ArticleLink } from 'components/Links';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';
import List from 'components/List';

export interface RelatedArticlesProps {
  relatedArticles?: DocumentLink[];
  ubi: UbiArticlePage;
}

const RelatedArticles = ({ relatedArticles = [], ubi }: RelatedArticlesProps) => {
  const { t } = useTranslation();

  if (!relatedArticles.length) return null;

  return (
    <>
      <Text as="h2" variant="bodyMediumBold" paddingBottom={spacer8}>
        {t('related_articles')}
      </Text>
      <List>
        {relatedArticles.map((relatedArticle, index) => (
          <li key={relatedArticle.slug}>
            <ArticleLink
              slug={relatedArticle.slug}
              semanticColor="textBrightAccent"
              queryParams={{ ref: 'related' }}
              eventDefinition={{
                category: 'related_articles',
                action: 'click_related_article',
                label: relatedArticle.slug,
              }}
              ubiFactory={ubi.logRelatedArticle(relatedArticle.slug, index)}
            >
              {relatedArticle.title}
            </ArticleLink>
          </li>
        ))}
      </List>
    </>
  );
};

export default RelatedArticles;
